import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import StyledTooltip from "../Wrapper/StyledTooltip";
import RequestFlagIconList, { RequestFlagIconListProps, GUTTER_SPACING_DEFAULT } from "./RequestFlagIconList";

const useStyles = makeStyles((theme) => ({
  containerWithGutters: (props: RequestFlagIconListProps) => ({
    "&> * + *": {
      marginLeft: theme.spacing(props.gutterSpacing || GUTTER_SPACING_DEFAULT),
    },
  }),
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

function WithFlagIconsList(props: React.PropsWithChildren<RequestFlagIconListProps> & { tooltipForChildren?: string }) {
  const { children, tooltipForChildren, ...propsNoChildren } = props;
  const { containerWithGutters, ellipsis } = useStyles(propsNoChildren);

  return (
    <Box alignItems="center" display="flex" className={containerWithGutters}>
      <RequestFlagIconList {...propsNoChildren} />
      {tooltipForChildren ? (
        <StyledTooltip title={tooltipForChildren}>
          <span className={ellipsis}>{children}</span>
        </StyledTooltip>
      ) : (
        <span className={ellipsis}>{children}</span>
      )}
    </Box>
  );
}

export default WithFlagIconsList;
